import cx from 'classnames';
import React from 'react';

import { Feature, SubnavSection } from '../../../types';
import FeatureBox from './FeatureBox';
import NavColumn from './NavColumn';
import SubnavLinksSection from './SubnavLinksSection';
import * as Styles from './Template.module.scss';

interface TemplateProps {
  sections: SubnavSection[] | undefined;
  features: Feature[] | undefined;
}

interface PrimarySubnavGroupProps {
  section: SubnavSection;
  features: Feature[] | undefined;
}

interface SecondarySubnavGroupProps {
  sections: SubnavSection[];
}

const PrimarySubnavGroup: React.FC<PrimarySubnavGroupProps> = ({
  section,
  features,
}) => {
  return (
    <NavColumn className={Styles.PrimaryNavColumn}>
      <SubnavLinksSection section={section} />
      {features !== undefined && features?.length > 0 && (
        <div
          className={cx(
            Styles.MegaMenuLinksContainer,
            Styles.MegaMenuLinksContainerHasNarrowGap,
            Styles.MegaMenuLinksContainerHasTextLinkAfter,
          )}
        >
          {features?.map((feature, index) => (
            <FeatureBox key={index} feature={feature} />
          ))}
        </div>
      )}
    </NavColumn>
  );
};

const SecondarySubnavGroup: React.FC<SecondarySubnavGroupProps> = ({
  sections,
}) => {
  return (
    <NavColumn className={Styles.SecondaryNavColumn} secondary>
      {sections.map((section, index) => (
        <SubnavLinksSection key={index} section={section} />
      ))}
    </NavColumn>
  );
};

const TemplateA: React.FC<TemplateProps> = ({ sections, features }) => {
  const [primary, secondary] = React.useMemo(() => {
    if (!sections || sections.length === 0) {
      return [null, []];
    }
    return [sections[0], sections.slice(1)];
  }, [sections]);

  if (!primary) {
    return null;
  }

  return (
    <div className={Styles.MegaMenu}>
      <div className={Styles.MegaMenu__Desktop}>
        <PrimarySubnavGroup section={primary} features={features} />
        <SecondarySubnavGroup sections={secondary} />
      </div>
    </div>
  );
};

export default TemplateA;
